module.exports = __webpack_public_path__ + "img/Spniach.50ebedd7.svg";